/* eslint react/jsx-props-no-spreading: 0 */
import React from 'react';

import AORTypes from '../../types';
import {
  SignIn,
} from '../user';
import PendingTours from './PendingApps';

class AuditorHome extends React.Component {
  constructor(props, context) {
    super(props, context);

    // eslint-disable-next-line react/no-unused-class-component-methods
    this.displayName = 'AuditHome';
  }

  render() {
    const { user, userData } = this.props;

    // TODO(clairbee): add a home page with stats and the number of actions items

    if (user && userData) {
      return (
        <PendingTours {...this.props} />
      );
    }

    return (
      <SignIn {...this.props} />
    );
  }
}

AuditorHome.defaultProps = {
  user: null,
  userData: null,
};

AuditorHome.propTypes = {
  user: AORTypes.AWS.Cognito.User,
  userData: AORTypes.User,
};

export default AuditorHome;
